<template>
    <div class="container mt-1" v-if="promociones.length">
        <div class="row d-flex">
            <div class="col-12 col-md-1 d-flex">
                <div class="p-3 text-white w-100">
                    <div class="promociones-text">PROMOCIONES</div>
                </div>
            </div>
            <div class="col-12 col-md-11 d-flex">
                <div class="w-100">
                    <div id="myCarousel" ref="carousel" class="carousel carousel-dark slide carousel-fade">
                        <!-- Barra de progreso -->
                        <div class="carousel-progress-bar">
                            <div class="carousel-progress-fill" :style="{ width: progress + '%' }"></div>
                        </div>

                        <div class="carousel-inner">
                            <div v-for="(item, index) in promociones" :key="item.id" class="carousel-item"
                                :class="{ active: index === 0 }">
                                <router-link :to="{ name: 'detalleProducto', query: { codigo: item.k_parte } }"
                                    style="border: none;text-decoration: none;cursor: pointer;">
                                    <div class="card mb-3" style="height: 100%; min-height: 300px; border: none;">
                                        <div class="row g-0">
                                            <div class="col-md-5 d-flex justify-content-center align-items-center">
                                                <div class="card-body text-center">
                                                    <BadgesProducto :item="item" wrapperClass="d-flex flex-wrap gap-2"
                                                        :fontSize="'13px'" />
                                                    <h3 class="card-title mt-1">{{ item.k_parte }}</h3>
                                                    <p class="card-text" v-if="item.linea">{{ item.linea }}</p>
                                                    <p class="card-text" v-if="item.descripcion">
                                                        <small class="text-muted">{{ item.descripcion }}</small>
                                                    </p>
                                                    <div class="mb-1"
                                                        style="min-height: 40px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                        <span v-if="item.aplicaciones && item.aplicaciones.length > 0"
                                                            class="card-text-sugerencia">
                                                            {{ item.aplicaciones[0].marca }} - {{
                                                                item.aplicaciones[0].modelo }} ({{
                                                                item.aplicaciones[0].year }})
                                                            <span
                                                                v-if="item.aplicaciones[0].posicion && item.aplicaciones[0].posicion !== '-'">
                                                                <strong>{{ item.aplicaciones[0].posicion
                                                                }}</strong> -
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-5 d-flex justify-content-center align-items-center">
                                                <img :src="item.PicturesUrl[item &&
                                                    item.categorias[0] &&
                                                    item.categorias[0].marcas &&
                                                    item.categorias[0].marcas.viewimagesgde ? item.categorias[0].marcas.viewimagesgde : 4] ? item.PicturesUrl[item &&
                                                        item.categorias[0] &&
                                                        item.categorias[0].marcas &&
                                                        item.categorias[0].marcas.viewimagesgde ? item.categorias[0].marcas.viewimagesgde : 4].sm : 'img/display/Placeholder.webp'"
                                                    alt="Producto Image" class="card-img-top img-fluid fixed-img"
                                                    style=" max-height: 300px; object-fit: cover; width: 300px; height: 300px;" />
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel } from "bootstrap";
import BadgesProducto from '../../../../App/Sales/DDP/visual_assets/Badges.vue';
export default {
    name: 'SliderPromoActivas',
    components: {
        BadgesProducto
    },
    data() {
        return {
            promociones: [],
            progress: 0,
            intervalId: null,
            carouselInstance: null,
        };
    },
    methods: {
        getImagePath(relativePath) {
            return `${window.location.origin}/${relativePath}`;
        },
        getPromociones() {
            axios
                .get("/api/controllerpeticiones/getpromociones")
                .then((response) => {
                    this.promociones = Array.isArray(response.data.filtrado)
                        ? response.data.filtrado
                        : Object.values(response.data.filtrado);
                    this.$nextTick(() => {
                        this.initCarousel();
                    });
                })
                .catch((error) => {
                    console.error("Error al obtener promociones", error);
                });
        },
        initCarousel() {
            // 1. Limpieza total previa
            if (this.carouselInstance) {
                this.carouselInstance.dispose();
                this.carouselInstance = null;
            }
            clearInterval(this.intervalId);

            // 2. Verificar que el elemento existe en el DOM
            const carouselEl = this.$refs.carousel;
            if (!carouselEl) return;

            // 3. Inicializar
            try {
                this.carouselInstance = new Carousel(carouselEl, {
                    interval: 1500,
                    ride: 'carousel',
                    pause: false // Opcional: evita que se detenga al pasar el mouse
                });

                this.startProgress();

                // Escuchar evento slide
                carouselEl.addEventListener("slide.bs.carousel", () => {
                    this.progress = 0;
                });
            } catch (error) {
                console.error("Error inicializando Bootstrap Carousel:", error);
            }
        },
        startProgress() {
            const duration = 1500; // ms del intervalo
            const step = 50;
            clearInterval(this.intervalId);
            this.progress = 0;

            this.intervalId = setInterval(() => {
                this.progress += (step / duration) * 100;
                if (this.progress >= 100) {
                    this.progress = 0;
                }
            }, step);
        },
    },
    mounted() {
        this.getPromociones();
    },
    beforeUnmount() {
        if (this.carouselInstance) {
            this.carouselInstance.dispose();
        }
        clearInterval(this.intervalId);
    },
};
</script>

<style scoped>
.banner-image img {
    width: 100px;
    margin-right: 20px;
}

.promociones-text {
    width: 100%;
    padding: 20px;
    text-align: center;
    background: #06283c;
    display: inline-block;
    overflow-wrap: break-word;
}

/* Media query para pantallas pequeñas: mostrar texto de manera horizontal */
@media (max-width: 767px) {
    .promociones-text {
        writing-mode: unset;
        font-size: 1.5rem;
    }
}

.carousel-item img {
    width: 100%;
    height: auto;
}

/* Barra de progreso personalizada */
.carousel-progress-bar {
    position: relative;
    height: 4px;
    background-color: #ddd;
    width: 100%;
    margin-bottom: 10px;
    border-radius: 2px;
    overflow: hidden;
}

.carousel-progress-fill {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background-color: #06283c;
    width: 0%;
    transition: width 0.05s linear;
}
</style>